import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var ExhibitorsIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M12 13c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
                        }),
                        _jsx("path", {
                            d: "M22 16h-1V6h1c.55 0 1-.45 1-1s-.45-1-1-1h-1V3c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v1H2c-.55 0-1 .45-1 1s.45 1 1 1h1v10H2c-.55 0-1 .45-1 1s.45 1 1 1h1v3c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-3h1c.55 0 1-.45 1-1s-.45-1-1-1zm-3 5H5v-3h14v3zm-9.22-5c.55-.61 1.34-1 2.22-1 .88 0 1.67.39 2.22 1H9.78zM19 15v1h-2.42c-.77-1.76-2.53-3-4.58-3-2.05 0-3.8 1.24-4.58 3H5V6h14v9zm0-11H5V3h14v1z"
                        })
                    ]
                })
            })
        ]
    });
};
ExhibitorsIcon.isCarinaIcon = true;
export default ExhibitorsIcon;
